export { default } from './ActivityDetailsMapWrapper';
